import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";

export default function PlataStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <SelectField
        label="Tipul pretului"
        value={data.tipPret}
        onChange={update("tipPret")}
        options={[
          { value: "fix", label: "Suma fixa" },
          { value: "ora", label: "Per ora" },
          { value: "zi", label: "Per zi" },
          { value: "luna", label: "Per luna" },
        ]}
        half
      />

      <InputField label="Suma" value={data.pretSuma} onChange={update("pretSuma")} placeholder="ex: 5000" type="number" required half error={errors.pretSuma} />

      <SelectField
        label="Moneda"
        value={data.pretMoneda}
        onChange={update("pretMoneda")}
        options={[
          { value: "RON", label: "RON" },
          { value: "EUR", label: "EUR" },
        ]}
        half
      />

      <SelectField
        label="Termen de plata"
        value={data.termenPlata}
        onChange={update("termenPlata")}
        options={[
          { value: "finalizare", label: "La finalizarea serviciilor" },
          { value: "lunar", label: "Lunar" },
          { value: "factura15", label: "La emiterea facturii + 15 zile" },
          { value: "factura30", label: "La emiterea facturii + 30 zile" },
        ]}
        half
        error={errors.termenPlata}
      />
    </div>
  );
}
